export const ROUTES = { home: '/' };
